import React from 'react';
import { number, string } from 'prop-types';
import style from './NotificationCounter.module.scss';
import cx from 'classnames';

const NotificationCounter = ({ count, className }) => {
  return <span className={cx(style.notificationCounter, className)}>{count}</span>;
};

NotificationCounter.propTypes = {
  count: number,
  className: string,
};

export default NotificationCounter;
